import { enableDebugLogRef, isDebugRef } from '../App';
import { ITransactionLog, LogType } from '../models/log.model';
import storeRef from '../store';
import { addTransactionLogStoreAsync } from '../store/logSlice';
import { stringifyJson } from './util';

let store: typeof storeRef | undefined;
export const injectStore = (_store: typeof storeRef) => {
  store = _store;
};

const buildBaseStyles = (override?: object) => {
  const style = Object.entries({
    ...baseStylesObj,
    ...override,
  }).reduce((arr, [val, key]) => {
    arr.push(`${val}: ${key}`);
    return arr;
  }, [] as string[]);

  return style.join(';');
};

const baseStylesObj = {
  color: '#000',
  'background-color': '#eee',
  padding: '2px 4px',
  'border-radius': '2px',
};

const errorStyles = buildBaseStyles({
  'background-color': '#c60000',
  color: '#fff',
});
const warnStyles = buildBaseStyles({
  'background-color': '#ffe400',
  color: '#000',
});
// const transactionStyles = buildBaseStyles({
//   color: '#9ea200',
// });
const infoStyles = buildBaseStyles();

const logError = (title: string, payloadData?: any) => {
  const payload = stringifyJson(payloadData);
  console.log(`%c${title}`, errorStyles, payload);
};

const logInternal = (title: string, payloadData?: any) => {
  const payload = stringifyJson(payloadData);
  console.log(`%c${title}`, infoStyles, payload);
};

const logWarn = (title: string, payloadData?: any) => {
  // Only capture warnings when debug mode or debug logging is enabled
  if (isDebugRef || enableDebugLogRef) {
    const payload = stringifyJson(payloadData);
    console.log(`%c${title}`, warnStyles, payload);
  }
};

const logInfo = (title: string, payloadData?: any) => {
  // Only capture infos when debug mode or debug logging is enabled
  if (isDebugRef || enableDebugLogRef) {
    const payload = stringifyJson(payloadData);
    console.log(`%c${title}`, infoStyles, payload);
  }
};

export const logConsole = (logType: LogType, title: string, payloadData?: any) => {
  if (title) {
    switch (logType) {
      case LogType.Error:
        logError(title, payloadData);
        break;
      case LogType.Warn:
        logWarn(title, payloadData);
        break;
      case LogType.Internal:
        logInternal(title, payloadData);
        break;
      default:
        logInfo(title, payloadData);
    }
  }
};

export const logTransaction = async (logType: LogType, transactionLog: string, payload?: any) => {
  logConsole(logType, `[TRANS] ${transactionLog}`, payload);
  if (transactionLog) {
    await store?.dispatch(
      addTransactionLogStoreAsync({
        typ: logType,
        msg: transactionLog,
        dt: new Date().getTime(),
      } as ITransactionLog),
    );
  }
};
